import React, { useMemo } from 'react';

import { TemplateStudioModel } from 'common/contracts';

import { cn } from 'components/lib/utils';
import { ETemplateStudioBundlesViewModel } from 'components/TemplatesStudio/enums';

type offersPerRowType = TemplateStudioModel['bundle']['offersPerRow'];

const mapValueToAmount: Partial<
  Record<ETemplateStudioBundlesViewModel, number>
> = {
  [ETemplateStudioBundlesViewModel.LINEAR]: 1,
  [ETemplateStudioBundlesViewModel.TWO_IN_ONE]: 2,
  [ETemplateStudioBundlesViewModel.THREE_IN_ONE]: 3
};

const SelectionBoxOption: React.FC<{
  viewModel: ETemplateStudioBundlesViewModel;
  isSelected: boolean;
  onClick: (value: offersPerRowType) => void;
}> = ({ viewModel, isSelected, onClick }) => {
  const blocksAmount = useMemo(() => mapValueToAmount[viewModel], [viewModel]);

  const handleClick = () => {
    if (isSelected) onClick(null);
    else onClick(viewModel);
  };

  return (
    <div
      className={cn(
        'flex gap-1 w-[90px] h-[38px] p-[10px] rounded-lg border border-base hover:shadow-md cursor-pointer',
        isSelected && 'border-base-black'
      )}
      onClick={handleClick}
    >
      {Array.from({ length: blocksAmount || 3 }).map((_, index) => (
        <div key={index} className="w-full h-full bg-[#D9D9D9] rounded-[4px]" />
      ))}
    </div>
  );
};

export const TemplateStudioOfferPerRowSelect: React.FC<{
  value: offersPerRowType;
  onChange: (value: offersPerRowType) => void;
}> = ({ value, onChange }) => {
  return (
    <div className="flex flex-col gap-2">
      <div className="text-xs text-black text-left mt-1 mb-2">
        {'Offer Per Row (Mobile)'}
      </div>
      <div className="group/collapsible flex justify-between items-center w-full text-base-mutedForeground text-xs leading-5 font-sans">
        {Object.values(ETemplateStudioBundlesViewModel)
          .slice(0, 3)
          .reverse()
          .map((viewModel) => (
            <SelectionBoxOption
              key={viewModel}
              viewModel={viewModel as ETemplateStudioBundlesViewModel}
              isSelected={value === viewModel}
              onClick={onChange}
            />
          ))}
      </div>
    </div>
  );
};
